module.exports = __webpack_public_path__ + "img/no-drugs.e5b143c9.png";